// ** React Imports
import { ReactNode, forwardRef } from "react";

// ** Third Party Components
import Proptypes from "prop-types";
import classnames from "classnames";
import { notNullString, toUpperCaseUtil } from "@src/utility/StringUtil";
// ** Reactstrap Imports
import { Badge, Tag } from "reactstrap";


interface AvatarProps {
  img?: string ,
  size?: string,
  icon?: ReactNode,
  color?: 
    "primary"|
    "secondary"|
    "success"|
    "danger"|
    "info"|
    "warning"|
    "dark"|
    "light-primary"|
    "light-secondary"|
    "light-success"|
    "light-danger"|
    "light-info"|
    "light-warning"|
    "light-dark",
  status? : "online"| "offline"| "away"| "busy",
  badgeUp?: boolean,
  content?: string,
  tag? : Tag | 'div',
  initials?: boolean ,
  imgWidth?: string | number,
  className?: string,
  badgeText?: string,
  imgHeight?: string | number,
  badgeColor?: "primary"|
  "secondary"|
  "success"|
  "danger"|
  "info"|
  "warning"|
  "dark"|
  "light-primary"|
  "light-secondary"|
  "light-success"|
  "light-danger"|
  "light-info"|
  "light-warning"|
  "light-dark" | string ,
  imgClassName?: string,
  contentStyles?: object,
}

const Avatar = forwardRef<HTMLDivElement,AvatarProps >((props: AvatarProps ,ref ) => {
  // ** Props
  const {
    img,
    size,
    icon,
    color,
    status,
    badgeUp,
    content,
    tag: Tag,
    initials,
    imgWidth,
    className,
    badgeText,
    imgHeight,
    badgeColor,
    imgClassName,
    contentStyles,
    ...rest
  } = props;

  // ** Function to extract initials from content
  const getInitials = (str: string|  undefined) => {
    const results = [] as string[];
    if(str){
      const wordArray = str.split(" ");
      wordArray.forEach((e,index,arr) => {
        if(arr.length === 1){
          results.push(e[0]);
          results.push(e[1]);
        } else {
          results.push(e[0]);
        }
        
      });
    }
    return toUpperCaseUtil(results.join(""));
  };

  return (
    <div
      className={classnames("avatar", {
        [notNullString(className)]: className,
        [`bg-${color}`]: color,
        [`avatar-${size}`]: size,
      })}
      ref={ref}
      {...rest}
    >
      {img === undefined ? (
        <span
          className={classnames("avatar-content", {
            "position-relative": badgeUp,
          })}
          style={contentStyles}
        >
          {initials ? getInitials(content) : content}

          {icon ? icon : null}
          {badgeUp ? (
            <Badge
              color={badgeColor ? badgeColor : "primary"}
              className="badge-sm badge-up"
              pill
            >
              {badgeText ? badgeText : "0"}
            </Badge>
          ) : null}
        </span>
      ) : (
        <img
          className={classnames({
            [notNullString(imgClassName)]: imgClassName,
          })}
          src={img}
          alt="avatarImg"
          height={imgHeight && !size ? imgHeight : 32}
          width={imgWidth && !size ? imgWidth : 32}
        />
      )}
      {status ? (
        <span
          className={classnames({
            [`avatar-status-${status}`]: status,
            [`avatar-status-${size}`]: size,
          })}
        ></span>
      ) : null}
    </div>
  );
});

export default Avatar;

// ** PropTypes
// Avatar.propTypes = {
//   icon: Proptypes.node,
//   src: Proptypes.string,
//   badgeUp: Proptypes.bool,
//   content: Proptypes.string,
//   badgeText: Proptypes.string,
//   className: Proptypes.string,
//   imgClassName: Proptypes.string,
//   contentStyles: Proptypes.object,
//   size: Proptypes.oneOf(["sm", "lg", "xl"]),
//   tag: Proptypes.oneOfType([Proptypes.func, Proptypes.string]),
//   status: Proptypes.oneOf(["online", "offline", "away", "busy"]),
//   imgHeight: Proptypes.oneOfType([Proptypes.string, Proptypes.number]),
//   imgWidth: Proptypes.oneOfType([Proptypes.string, Proptypes.number]),
//   badgeColor: Proptypes.oneOf([
//     "primary",
//     "secondary",
//     "success",
//     "danger",
//     "info",
//     "warning",
//     "dark",
//     "light-primary",
//     "light-secondary",
//     "light-success",
//     "light-danger",
//     "light-info",
//     "light-warning",
//     "light-dark",
//   ]),
//   color: Proptypes.oneOf([
//     "primary",
//     "secondary",
//     "success",
//     "danger",
//     "info",
//     "warning",
//     "dark",
//     "light-primary",
//     "light-secondary",
//     "light-success",
//     "light-danger",
//     "light-info",
//     "light-warning",
//     "light-dark",
//   ]),
//   initials(props:any) {
//     if (props["initials"] && props["content"] === undefined) {
//       return new Error("content prop is required with initials prop.");
//     }
//     if (props["initials"] && typeof props["content"] !== "string") {
//       return new Error("content prop must be a string.");
//     }
//     if (
//       typeof props["initials"] !== "boolean" &&
//       props["initials"] !== undefined
//     ) {
//       return new Error("initials must be a boolean!");
//     }
//   },
// };

// // ** Default Props
// Avatar.defaultProps = {
//   tag: "div",
// };
